import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@independent-software/typeui/controls/Button';
import { Icon } from '@independent-software/typeui/controls/Icon';

import { AuthContext } from '../../AuthContext';
import { Container, Content, BottomBar } from '../../modules';
import { Parameter } from '../../resource/';
import { ListParameters } from './ListParameters';
import { Gate } from '../../controls/Gate';

const ParameterList = () => {
  const auth = React.useContext(AuthContext);
  const navigate = useNavigate();

  const handleAdd = () => {
    navigate('/parameters/add');
  }  

  const handleClick = (item: Parameter) => {
    navigate(`/parameters/${item.id}`);
  }  

  return (
    <Container>
      <Content>
        <ListParameters auth={auth} name="parameters" onClick={handleClick}/>
      </Content>
      <BottomBar>
        <Gate right='can_edit_parameters'>
          <Button primary onClick={handleAdd}><Icon name="plus"/> Add parameter</Button>
        </Gate>
      </BottomBar>
    </Container>
  );
}

export { ParameterList }
